module.exports = __webpack_public_path__ + "img/lelin-app.87e2b93e.jpg";